const main = 'elevators'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
  relativeDetail: ':id',
}

const routes = {
  List: `/${main}`,
  Details: `/${main}/${relativeRoutes.relativeDetail}`,
}

const ElevatorRoutes = { ...relativeRoutes, ...routes }

export default ElevatorRoutes
